<template>
  <div v-if="message" class="license-banner" :class="'license-banner--' + status">
    {{ message }}
  </div>
</template>

<script>
import ConfigService from '@/services/config.service';
import { formatDate, getLicenseStatus } from '@/utils/page-utils';

export default {
    name: 'LicenseBanner',
    data() {
        return {
            expirationDate: null
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isAdmin() {
            return Boolean(this.currentUser && this.currentUser.roles && this.currentUser.roles.includes('ROLE_ADMIN'));
        },
        status() {
            return getLicenseStatus(this.expirationDate).status;
        },
        message() {
            if (this.status === null || this.status === 'active') {
                return null;
            }
            const formattedDate = formatDate(this.expirationDate);

            if (this.status === 'expired') {
                return `Tu licencia venció el ${formattedDate}. Contactate para renovar.`;
            }
            return `Tu licencia vence el ${formattedDate}.`;
        }
    },
    created() {
        if (this.isAdmin) {
            ConfigService.getLicenseInfo().then(
                response => {
                    this.expirationDate = response.data && response.data.expirationDate;
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../styles/theme.scss";

.license-banner {
    padding: 8px 20px;
    font-size: 13px;
    font-weight: 600;
    text-align: center;

    &--warning {
        background-color: $issue-warning-soft;
        color: darken($issue-warning, 20%);
    }

    &--expired {
        background-color: $issue-danger-soft;
        color: darken($issue-danger, 5%);
    }
}
</style>
